import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { IconMaterial } from '@uhg-abyss/web/ui/IconMaterial';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import PropTypes from 'prop-types';
import { AccountHeader } from '../../TopNav';

const StyledHeading = styled(Heading, {
  '&.abyss-heading-root': {
    marginTop: '16px',
    padding: '8px 16px',
    fontWeight: 'bold',
    fontSize: '18px',
    color: '$gray8 !important',
  },
});

const StyledFlexDiv = styled('div', {
  display: 'flex',
  gap: '5px',
  alignItems: 'center',
});

export const ProfileContent = ({ user }) => {
  return (
    <React.Fragment>
      <StyledHeading offset={4}>
        <StyledFlexDiv
          data-testid="user-firstName-link"
          data-cy="profile-and-setting-dropdown-btn"
        >
          <IconMaterial icon="account_circle" />
          {user.firstName}
        </StyledFlexDiv>
      </StyledHeading>
      <AccountHeader />
    </React.Fragment>
  );
};

ProfileContent.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
  }).isRequired,
};
